import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';

const CustomTabs = ({
  tabs,
  selectedTab,
  onTabChange,
  className = 'mb-3',
  tabsCount = [],
  disabledTabs = [],
  errorTabs = [],
}) => {
  return (
    <Nav className={`custom-tabs w-100 ${className}`} tabs>
      {tabs.map((tab, i) => (
        <NavItem key={tab}>
          <NavLink
            className="border-0 mb-0 bg-transparent"
            active={selectedTab === tab}
            onClick={() => {
              onTabChange(tab);
            }}
            disabled={disabledTabs.includes(tab)}
          >
            <span className="custom-tabs__label">
              {tab} {tabsCount.length > 0 && `(${tabsCount[i]})`}
              {errorTabs.includes(tab) && (
                <span className="custom-tabs__error-dot" />
              )}
            </span>
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
};

export default CustomTabs;
